// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__Zp5lv","sendOtp":"AuthorizeToLogin_sendOtp__WniYt"};